import React from 'react';

import MetaTags from 'components/meta-tags';
import { Card, LoadingContent } from './card';

export function IrlEventLoading(): JSX.Element {
  return (
    <>
      <MetaTags title='Loading...' description='Loading event details' />

      <Card data-testid='irl-event-loading'>
        <LoadingContent />
      </Card>
    </>
  );
}
